import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    abteilungen: undefined,
    isLoadingAbteilungen: true,
  }
}

export function fulfilled(state, payload, result) {
  return {
    ...state,
    abteilungen: result,
    isLoadingAbteilungen: false,
  }
}

export function rejected(state) {
  return {
    ...state,
    isLoadingAbteilungen: false,
  }
}

export async function action(payload) {
  try {
    return await Api.getAbteilungenForAzubi(payload.azubiId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
